module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-4e225744.png";